module.exports = __webpack_public_path__ + "static/media/rollerblade4.24ccf6d7.gif";